<template>
  <div
    class="profile-form"
    :class="{
      'name-invalid': isSubmitted && nameError,
      'positions-invalid': isSubmitted && positionsError,
    }"
  >
    <div class="row">
      <div class="col col-12 col-md-4 col-xl-3 profile-form__name">
        <div
          class="form-group"
          :class="{
            'is-invalid': isSubmitted && nameError,
          }"
        >
          <c-input
            v-model="form.name"
            floating-label="Наименование"
            :required-mark="true"
            :clearable="true"
            :required="isSubmitted && nameError"
            :required-message="isSubmitted && nameError"
          />
        </div>
      </div>
      <div class="col col-12 col-md-6 col-xl-6 profile-form__positions">
        <div
          class="form-group"
          :class="{
            'is-invalid': isSubmitted && positionsError,
          }"
        >
          <c-input
            v-model="form.positions"
            type="select"
            floating-label="Должности"
            :required-mark="true"
            :searchable="true"
            :items="collections.positions"
            :multiple="true"
            :required-message="isSubmitted && positionsError"
            :required="isSubmitted && positionsError"
          />
        </div>
      </div>
      <div class="col profile-form__actions">
        <div class="form-group">
          <div class="profile-form__actions-container">
            <c-button class="profile-form__reset" label="Сбросить" size="large" :disabled="pending" @click="reset" />
            <c-button
              class="profile-form__save"
              label="Сохранить"
              color="primary"
              size="large"
              :disabled="pending"
              @click="submit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import { formatProfileData } from "../../models/ProfileData";
import { REQUIRED_ERROR } from "@/constants/errorFieldValues";

export default {
  components: { CInput, CButton },
  props: ["profileData"],
  data() {
    return {
      loading: false,
      isSubmitted: false,
      pending: false,

      id: null,

      savedData: {
        name: "",
        positions: [],
      },
      form: {
        name: "",
        positions: [],
      },
      collections: {
        positions: [],
      },
    };
  },
  computed: {
    nameError() {
      return this.form.name.trim().length ? null : REQUIRED_ERROR;
    },
    positionsError() {
      return this.form.positions.length ? null : REQUIRED_ERROR;
    },
    isValid() {
      return !this.nameError && !this.positionsError;
    },
  },
  watch: {
    profileData(v) {
      this.setData(v);
    },
  },
  async created() {
    this.loading = true;
    await this.loadPositions().then((list) => {
      this.collections.positions = list;
    });

    if (this.profileData) {
      this.setData(this.profileData);
    } else {
      const { posts } = this.$route.query;
      const postCodes = (posts || "")
        .split(",")
        .filter((code) => this.collections.positions.some((i) => i.value === code));


      this.form.positions = postCodes.map((code) => ({ value: code }));
    }

    this.loading = false;
  },
  methods: {
    loadPositions() {
      return this.$store.dispatch("positions/getPositionsList");
    },
    setData(data) {

      if (!data) {
        return;
      }
      const { id, name, positions } = data;

      this.id = id;

      const positionsValue = positions.map((positionCode) => {
        var p = this.collections.positions.find((i)=>i.value==positionCode);
        return { value: positionCode, label: p ? p.label : '' }
      });

      this.savedData.name = name;
      this.savedData.positions = [...positionsValue];

      this.form.name = name;
      this.form.positions = [...positionsValue];
    },

    getParams() {
      const { name, positions } = this.form;
      const profileParams = {
        name,
        positions: positions.map((position) => position.value),
      };

      const params = {
        ...formatProfileData(profileParams),
      };

      if (this.id) params.id = this.id;
      return params;
    },
    submit() {
      this.isSubmitted = true;
      if (!this.isValid) return;

      this.pending = true;
      const params = this.getParams();
      //console.log(params);
      const editMode = !!this.id;
      const action = editMode ? "profile/updateProfile" : "profile/createProfile";

      this.$store
        .dispatch(action, params)
        .then((data) => {
          const { model } = data;

          this.$notify({
            group: "success-message",
            data: {
              textMessage: editMode
                ? `Настройки анкеты <b>${this.form.name}</b> успешно сохранены`
                : `Анкета <b>${this.form.name}</b> успешно создана`,
            },
          });

          this.$emit("updated", model);
        })
        .catch(() => {
          this.$notify({
            group: "error-message",
            data: {
              textMessage: "Произошла ошибка. Попробуйте ещё раз.",
            },
          });
        })
        .finally(() => {
          this.isSubmitted = false;
          this.pending = false;
        });
    },
    reset() {
      this.form.name = this.savedData.name;
      this.form.positions = this.savedData.positions;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
@import "~@/assets/styles/grid";

.profile-form {
  padding-bottom: 10px;

  &__positions {
    /deep/ {
      .c-input-required {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  &__actions {
    width: auto;
    margin-left: auto;
    flex-grow: 0;
  }

  &__actions-container {
    display: flex;
    margin-left: -5px;
    margin-right: -5px;
  }

  &__reset,
  &__save {
    margin-left: 5px;
    margin-right: 5px;
  }

  .is-invalid {
    padding-bottom: 24px;
  }

  @include beforeBootstrapMd {
    &__actions {
      width: 100%;
      margin-left: 0;
    }
    &__reset,
    &__save {
      flex-grow: 1;
      flex-basis: 50%;
      flex-shrink: 1;
    }
  }

  @include bootstrapMd {
    @include gridGenerator(10);
  }

  @include bootstrapXl {
    @include gridGenerator(12);
    .row {
      flex-wrap: nowrap;
    }
    &__positions {
      flex-shrink: 1 !important;
    }
    &__actions {
      padding-top: 15px;
    }
  }
}
</style>
